export default "__VITE_ASSET__1395db56__"